/**
 * Deal-specific form data builders.
 *
 * Builds guardrails for DEAL campaign type from form state.
 * Extracted from formDataBuilder for single-responsibility.
 *
 * @module dealDataBuilder
 */

import { DealGuardrails } from 'src/@types/valueMatching/guardrails';
import { UseCampaignFormResult } from 'src/hooks/useCampaignForm/useCampaignForm';
import { parseOptionalNumber } from 'src/utils/helpers';

// ============================================================================
// Public API
// ============================================================================

/** Builds Deal guardrails from form state. */
export function buildDealGuardrails(form: UseCampaignFormResult): DealGuardrails {
    const guardrails: DealGuardrails = {};

    const dealPercent = parseOptionalNumber(form.dealPercentOfOriginalDealPrice);
    if (dealPercent != null) {
        guardrails.percentOfOriginalDealPriceGuardrail = dealPercent;
    }

    return guardrails;
}
